<script>
  import { onMount } from "svelte";
  import { api, pcd, msg, messages, unitprice, maxunits, entry, unitdetails, explanation, winningannouncement, personalinfo, emaillead, emailreceptionsettings, salesdatailstitles, emailhints, emailsendbtn, precautions } from "../stores.js";
  import { push } from "svelte-spa-router";
  import validator from "../validator.js";
  import Terms from "../components/Terms.svelte";
  import Privacy from "../components/Privacy.svelte";
  import Modal from "../components/Modal.svelte";

  let updateValidatedClass = (elm, invalid) => {
    if (invalid) {
      if (elm.classList.contains("valid")) elm.classList.remove("valid");
      if (!elm.classList.contains("invalid")) elm.classList.add("invalid");
    } else {
      if (elm.classList.contains("invalid")) elm.classList.remove("invalid");
      if (!elm.classList.contains("valid")) elm.classList.add("valid");
    }
    if (!elm.classList.contains("validated")) elm.classList.add("validated");
  };

  let loading = false;
  let showTermsModal = false;
  let showPrivacyModal = false;
  let showAlert = false;
  let alertmsg = "";
  let credential = null;

  let email = {
    input: {
      value: "",
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = email.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        m = "メールアドレスを入力してください。";
      } else if (200 < v.length || !validator.isEmail(v)) {
        m = "正しいメールアドレスを入力してください。";
      }
      updateValidatedClass(email.input, m);
      email.invalidmsg = m;
      return this;
    }
  };
  let termsagree = {
    input: {
      checked: false,
    },
    togglecheck: function(e) {
      if (termsagree.input && termsagree.input.checked) {
        termsagree.input.checked = false;
        $entry.termsagree = false;
        showTermsModal = true;
      }
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = termsagree.input.checked;
      if (!v) {
        m = "申込用URL送信には利用規約の同意が必要です。";
      }
      updateValidatedClass(termsagree.input, m);
      termsagree.invalidmsg = m;
      return this;
    }
  };
  let privacyagree = {
    input: {
      checked: false,
    },
    togglecheck: function(e) {
      if (privacyagree.input && privacyagree.input.checked) {
        privacyagree.input.checked = false;
        $entry.privacyagree = false;
        showPrivacyModal = true;
      }
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = privacyagree.input.checked;
      if (!v) {
        m = "申込用URL送信には個人情報の保護に関する規約の同意が必要です。";
      }
      updateValidatedClass(privacyagree.input, m);
      privacyagree.invalidmsg = m;
      return this;
    }
  };
  let forminputs = [email, termsagree, privacyagree];

  onMount(async () => {
    window.scroll(0, 0);
    try {
      loading = true;
      const response = await fetch($api + "/status/" + $pcd);
      const data = await response.json().catch(() => null);
      if (response.status == 200) {
        $entry.onsale = data.onsale;
        $entry.salestitle = data.title;
        $entry.salesterm = data.term;
        $entry.webauthn = data.wa;
        if (!data.onsale) {
          $msg = data.message;
          push("/message");
          return;
        }
      } else if ([429, 504].includes(response.status)) {
        $msg = $messages.busy;
        push("/message");
        return;
      } else {
        push("/error");
        return;
      }
    } catch (err) {
      push("/error");
      return;
    } finally {
      loading = false;
    }
  });

  async function handleSubmit(e) {
    if (loading) return;
    try {
      loading = true;
      let validateResults = [];
      for (let i = 0; i < forminputs.length; i++) {
        validateResults.push(forminputs[i].validate().invalidmsg);
      }
      if (validateResults.some((v) => 0 < v.length)) return;
      await callentry(email.input.value);
    } finally {
      loading = false;
    }
  }

  async function callentry(em) {
    try {
      const response = await fetch($api + "/entry", {
        mode: "cors",
        method: "POST",
        referrerPolicy: "unsafe-url",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: em,
          pcd: $pcd,
          credential: credential,
        }),
      });
      const data = await response.json().catch(() => null);
      if ([200, 201].includes(response.status)) {
        if ($entry.webauthn && !credential) {
          await creatCredential(data.challenge, data.id, email.input.value);
          return;
        }
        $entry.complete = true;
        push("/sending");
        return;
      } else if (response.status == 424) {
        $msg = data.message;
        push("/message");
        return;
      } else if ([429, 504].includes(response.status)) {
//        showAlert = true;
//        alertmsg = $messages.busy;
        $msg = $messages.busy;
        push("/message");
        return;
      } else {
        push("/error");
        return;
      }
    } catch (err) {
      push("/error");
      return;
    }
  }

  async function creatCredential(challenge, userid, em) {
    try {
      const cc = await navigator.credentials.create({
        publicKey: {
          challenge: Uint8Array.from(atob(challenge), c => c.charCodeAt(0)),
          rp: {
            name: window.location.hostname,
            id: window.location.hostname,
          },
          user: {
            id: Uint8Array.from(userid, c => c.charCodeAt(0)),
            name: em,
            displayName: em.substr(0, em.lastIndexOf("@")),
          },
          pubKeyCredParams: [
            {alg: -7, type: "public-key"},
            {alg: -257, type: 'public-key'},
          ],
          authenticatorSelection: {
            authenticatorAttachment: "platform",
          },
          //attestation: "indirect",
          //attestation: "direct",
          //timeout: 60000,
        }
      });
      credential = {};
      credential.id = cc.id;
      credential.rawId = btoa(String.fromCharCode.apply(null, new Uint8Array(cc.rawId)));
      credential.response = {};
      credential.response.attestationObject = btoa(String.fromCharCode.apply(null, new Uint8Array(cc.response.attestationObject)));
      credential.response.clientDataJSON = btoa(String.fromCharCode.apply(null, new Uint8Array(cc.response.clientDataJSON)));
      await callentry(em);
    } catch (e) {
      console.log(e);
      $msg = "お申し込みには端末認証が必要です。\n再度お手続きを行っていただけますようお願いいたします。";
      push("/message");
      return;
    }
  }

  function termsModalClosed(event) {
    if (event.detail.result) termsagree.input.checked = true;
    $entry.termsagree = termsagree.input.checked;
    showTermsModal = false;
  }

  function privacyModalClosed(event) {
    if (event.detail.result) privacyagree.input.checked = true;
    $entry.privacyagree = privacyagree.input.checked;
    showPrivacyModal = false;
  }

  function AlertClosed() {
    showAlert = false;
    alertmsg = "";
  }
</script>

<style>
  .btn-primary {
    min-width: 8.25rem;
  }
  .lead {
    color: #D50000 !important;
    font-weight: 700 !important;
    font-size: 1.25rem;
  }
</style>


{#if $entry.onsale}
  <h2>メールアドレスのご登録</h2>
  <h3>■ご説明事項</h3>
  <p class="ws-pl">
    <span class="d-block">{$explanation}</span>
    <strong>{$emailreceptionsettings}<br />
      <button class="btn btn-link" on:click|preventDefault={() => (push("/help"))}>メール受信設定方法</button>
    </strong>
  </p>
  <h3>■個人情報の取扱いについて</h3>
  <p class="ws-pl">
    <span class="d-block">{$personalinfo}</span>
    <span class="d-block">※その他個人情報の取扱いについては、このサイト下段「個人情報の取扱いについて」をご確認ください。
個人情報に関する利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去および第三者への提供の停止、および苦情等のお申し出を希望される場合は下記までご連絡ください。
    
    〔個人情報の取扱いに関する問い合わせ先〕
    〒162-0801
    東京都新宿区山吹町３４７番地　藤和江戸川橋ビル６階
    株式会社ＥＶＥＮＴＩＦＹ　個人情報保護管理者
    下記の「お問い合わせ」よりお問い合わせください。
    
    ※正確な情報をご入力いただけない場合、メール配信ができず登録ができないことがありますので、あらかじめ、ご了承ください。</span>
  </p>
  <dl class="row">
    <dt class="col two">{$salesdatailstitles.name}</dt><dd class="col ten">{$entry.salestitle}</dd>
    <dt class="col two">{$salesdatailstitles.term}</dt><dd class="col ten">{$entry.salesterm}</dd>
    <dt class="col two">{$salesdatailstitles.item}</dt><dd class="col ten">{$unitdetails}</dd>
    <dt class="col two">{$salesdatailstitles.price}</dt><dd class="col ten">{$unitprice.toLocaleString('ja-JP')}円／1セット</dd>
    <dt class="col two">{$salesdatailstitles.limitation}</dt><dd class="col ten">1セット{#if $maxunits>1}～{$maxunits}セット{/if}</dd>
    {#if $winningannouncement}
    <dt class="col two">{$salesdatailstitles.winningannouncement}</dt><dd class="col ten">{$winningannouncement}</dd>
    {/if}
  </dl>
  <p class="ws-pl">
    <span class="danger">{$precautions}</span>
  </p>
  <form on:submit|preventDefault={handleSubmit} novalidate>
    <div class="input-group">
      {#if $emaillead}
      <p class="lead">{$emaillead}</p>
      {/if}
      <label for="email">メールアドレス</label>
      <input
        bind:this={email.input}
        bind:value={$entry.email}
        on:blur={email.validate}
        placeholder="メールアドレス"
        type="text"
        id="email"
        required
        class="w100" />
        <div class="ifinvalid">{email.invalidmsg}</div>
        {#each $emailhints as emailhint}
        <div class="danger">{emailhint}</div>
        {/each}
      </div>
    <div class="input-group ta-center">
      <input
        type="checkbox"
        bind:this={termsagree.input}
        bind:checked={$entry.termsagree}
        on:click={termsagree.togglecheck}
        id="agree" />
        <button class="btn btn-link" on:click|preventDefault={() => (showTermsModal = true)}>利用規約</button><label for="agree">に同意する</label>
      <div class="ifinvalid">{termsagree.invalidmsg}<div class="danger">同意するには、チェックボックスを押して「利用規約」ページを開き、[同意する]ボタンを押してください。</div></div>
    </div>
    <div class="input-group ta-center">
      <input
        type="checkbox"
        bind:this={privacyagree.input}
        bind:checked={$entry.privacyagree}
        on:click={privacyagree.togglecheck}
        id="agree" />
        <button class="btn btn-link" on:click|preventDefault={() => (showPrivacyModal = true)}>個人情報の保護に関する規約</button><label for="agree">に同意する</label>
      <div class="ifinvalid">{privacyagree.invalidmsg}<div class="danger">同意するには、チェックボックスを押して「個人情報の保護に関する規約」ページを開き、[同意する]ボタンを押してください。</div></div>
    </div>
    <div class="mt-1 mb-1 flex jc-center">
      <button
      type="submit"
      class="btn-primary"
      disabled={loading}>{$emailsendbtn}</button>
    </div>
  </form>
  {#if showTermsModal}
    <Modal oktext="同意する" canceltext="戻る" on:close={termsModalClosed}>
      <h2 slot="header">利用規約</h2>
      <Terms />
    </Modal>
  {/if}
  {#if showPrivacyModal}
    <Modal oktext="同意する" canceltext="戻る" on:close={privacyModalClosed}>
      <h2 slot="header">個人情報の取扱いについて</h2>
      <Privacy />
    </Modal>
  {/if}
  {#if showAlert}
    <Modal oktext="" canceltext="閉じる" on:close={AlertClosed}>
      <div><p class="ws-pl">{alertmsg}</p></div>
    </Modal>
  {/if}
{/if}
